var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "text-align": "center" } },
    [
      _vm.wishBetMsg.data.type === "message"
        ? [
            _c("div", { staticClass: "dialog_text" }, [
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.wishBetMsg.data.content) }
              })
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "v-btn primary-btn",
                staticStyle: { "margin-left": "0px" },
                on: {
                  click: function($event) {
                    return _vm.closeDialog()
                  }
                }
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t("WishBets.CloseDialog")))])]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.wishBetMsg.data.type === "barcode"
        ? [
            _c(
              "div",
              { staticClass: "dialog_header" },
              [
                _c("span", { staticClass: "header_text" }, [
                  _vm._v(_vm._s(_vm.$t("WishBet.BarcodeInfo")))
                ]),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        return _vm.closeBarCodeDialog()
                      }
                    }
                  },
                  [_vm._v("close")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dialog_text" },
              [
                _c("vue-barcode", {
                  attrs: { value: _vm.wishBetMsg.data.content, format: "ITF14" }
                })
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.wishBetMsg.data.type === "confirmation_popup"
        ? [
            _c("div", { staticClass: "dialog_text" }, [
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.$t("WishBet.DeleteBetDesc")) }
              })
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "v-btn secondary-btn",
                staticStyle: { "margin-left": "0px" },
                on: {
                  click: function($event) {
                    return _vm.closeDialog()
                  }
                }
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t("WishBets.No")))])]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "v-btn primary-btn",
                staticStyle: { "margin-left": "0px" },
                on: {
                  click: function($event) {
                    return _vm.deleteWishBet()
                  }
                }
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t("WishBets.Yes")))])]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.wishBetMsg.data.type === "checkbet"
        ? [
            _c("div", {
              staticClass: "dialog_preheader",
              class: _vm.ticketStatusFormated
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dialog_header" },
              [
                _c("h3", [_vm._v(_vm._s(_vm.$t("WishBet.TicketInfo")))]),
                _vm._v(" "),
                _c(
                  "v-icon",
                  {
                    staticClass: "close",
                    on: {
                      click: function($event) {
                        return _vm.closeDialog()
                      }
                    }
                  },
                  [_vm._v("close")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.scannedTicketError
              ? _c("div", { staticClass: "dialog_text error_msg" }, [
                  _c("span", [
                    _vm._v(" " + _vm._s(_vm.scannedTicketError) + " ")
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.scannedTicketError
              ? _c("div", { staticClass: "dialog_text" }, [
                  _c("div", {
                    staticClass: "ticket_status_icon",
                    class: _vm.ticketStatusFormated
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "ticket_status",
                      class: _vm.ticketStatusFormated
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "WishBet.TicketInfo.Status" +
                                _vm.ticketStatusFormated
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "ticket_desc" }, [
                    _vm.scannedTicket.payoutAmount &&
                    _vm.ticketStatusFormated === "Unpaid"
                      ? _c("h3", { staticClass: "payout_amount" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("WishBet.TicketInfo.PayoutAmount")
                              ) +
                              " \n          "
                          ),
                          _c("span", { staticClass: "amount" }, [
                            _vm._v(
                              _vm._s(_vm.scannedTicket.currency) +
                                " " +
                                _vm._s(_vm.payoutAmountFormated)
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "WishBet.TicketInfo.Status" +
                              _vm.ticketStatusFormated +
                              "Desc"
                          )
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ticket_info" }, [
                    _c("span", { staticClass: "line" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("WishBet.TicketInfo.TicketId")))
                      ]),
                      _vm._v(" #" + _vm._s(_vm.scannedTicket.ticketId))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "line" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("WishBet.TicketInfo.Date")) + " ")
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.scannedTicket.placementTime,
                              _vm.dateFormats.longDate
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.scannedTicket.placementTime,
                              _vm.dateFormats.longTime
                            )
                          )
                        )
                      ])
                    ])
                  ])
                ])
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fd07123", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd07123","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/wishBetMsgDialog.vue
// module id = null
// module chunks = 